<template>
  <div style="min-width: 1033px" class="sorttable">
    <SearchBoxs
      @eserach="eserach"
      @onreduction="onreduction"
      @changeAccordion="changeAccordion"
      :reduct="reduct"
    ></SearchBoxs>
    <div
      ref="caozuo"
      class="caozuo"
      style="display: flex;justify-content: space-between;line-height: 40px;margin-bottom: 5px;
      "
    >
      <div>
        <el-button size="small" @click="shuaxin">
          <i class="el-icon-refresh-right"></i>
          刷新
        </el-button>
        <ExportExcel
          :E_ids="E_ids"
          :E_condition="E_condition"
          :E_dataLength="E_dataLength"
          :E_methodname="E_methodname"
          :E_searchArr="E_searchArr"
        ></ExportExcel>
      </div>
      <div>
        <el-form
          style="height: 40px"
          :model="formes"
          :inline="true"
          :rules="rules"
          ref="formes"
          label-width="90px"
        >
          <el-form-item label prop="mobile">
            <el-input
              size="small"
              placeholder="请输入用户手机号"
              v-model="formes.mobile"
              style="width: 200px"
              clearable
            >
              <i slot="suffix" class="el-input__icon el-icon-search"></i>
            </el-input>
          </el-form-item>
          <el-form-item label>
            <el-input
              size="small"
              placeholder="请输入主叫号码"
              v-model="caller"
              style="width: 200px"
              clearable
            >
              <i slot="suffix" class="el-input__icon el-icon-search"></i>
            </el-input>
          </el-form-item>
          <el-form-item label>
            <el-select
              v-model="field"
              placeholder="请选择"
              size="small"
              @change="switchover2"
              class="especially"
              style="width: 110px"
            >
              <el-option label="被叫号码" value="1"></el-option>
              <el-option label="X号码" value="2"></el-option>
            </el-select>
            <el-input
              size="small"
              :placeholder="switchtext1"
              v-model="search_field"
              style="width: 160px"
              class="especially2"
              clearable
            >
              <i slot="suffix" class="el-input__icon el-icon-search"></i>
            </el-input>
          </el-form-item>
          <el-button
            size="small"
            type="primary"
            :disabled="searchbtn"
            @click="inputsearch(1)"
            style="width: 130px"
          >
            {{ searchbtnstr }}
          </el-button>
        </el-form>
      </div>
    </div>
    <el-table
      :height="zhanshi"
      :data="tableData"
      style="width: 100%"
      :header-cell-style="headerCellStyle"
      @selection-change="handleSelectionChange"
      :cell-style="cellStyle"
      ref="multipleTable"
    >
      <el-table-column type="selection" fixed="left"></el-table-column>
      <el-table-column
        prop="caller"
        fixed="left"
        label="主叫号码"
        width="120"
      ></el-table-column>
      <el-table-column
        prop="x_number"
        fixed="left"
        label="X号码"
        width="120"
      ></el-table-column>
      <el-table-column
        prop="callee"
        fixed="left"
        width="120"
        label="被叫号码"
      ></el-table-column>
      <el-table-column prop="start_time" label="开始时间" sortable width="180">
        <template slot-scope="scope">{{ scope.row.stime }}</template>
      </el-table-column>
      <el-table-column prop="end_time" label="结束时间" sortable width="180">
        <template slot-scope="scope">
          <div v-show="scope.row.etime">
            {{ scope.row.etime }}
          </div>
          <div v-show="!scope.row.etime">
            {{ scope.row.etime ? "--" : "--" }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="use_time" label="通话时长(秒)" width="120">
        <template slot-scope="scope">{{
          scope.row.use_time ? scope.row.use_time + "秒" : "0秒"
        }}</template>
      </el-table-column>
      <!-- callTypeInfo -->
      <!-- <el-table-column prop="allTypeInfo" label="呼叫方式">
        <template slot-scope="scope">{{
          scope.row.callTypeInfo.name ? scope.row.callTypeInfo.name : "暂无"
        }}</template>
      </el-table-column> -->
      <el-table-column prop="seat_user_name" label="姓名" width="120">
        <template slot-scope="scope">{{
          scope.row.UserInfo.name ? scope.row.UserInfo.name : "暂无"
        }}</template>
      </el-table-column>
      <el-table-column prop="seat_user_name" label="手机号码" width="120">
        <template slot-scope="scope">{{
          scope.row.UserInfo.mobile ? scope.row.UserInfo.mobile : "暂无"
        }}</template>
      </el-table-column>
      <el-table-column prop="seat_user_name" label="归属代理商" width="120">
        <template slot-scope="scope">{{
          scope.row.ParentInfo.name ? scope.row.ParentInfo.name : "暂无"
        }}</template>
      </el-table-column>
      <el-table-column prop="call_type_id" label="卡种类" width="120">
        <template slot-scope="scope">{{
          calltypecard(scope.row.call_type_id_card)
        }}</template>
      </el-table-column>
      <el-table-column prop="seat_user_name" label="企业" width="120">
        <template slot-scope="scope">{{
          scope.row.CompanyInfo.name ? scope.row.CompanyInfo.name : "暂无"
        }}</template>
      </el-table-column>
      <el-table-column prop="hang_up_type" label="挂机原因" width="120">
        <template slot-scope="scope">
          <div :class="[scope.row.hang_up_type == 1 ? 'Success' : 'red']">
            {{ scope.row.hang_up_type == 1 ? "正常" : "系统黑名单" }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态">
        <template slot-scope="scope">
          {{ scope.row.status | daType }}
        </template>
      </el-table-column>
      <el-table-column label="设备信息" width="160">
        <template slot-scope="scope">
          {{ scope.row.UserInfo.append_json && scope.row.UserInfo.append_json.mobile_brand }}
          <br/>
          {{ scope.row.UserInfo.append_json && scope.row.UserInfo.append_json.mobile_model }}
          <br/>
          {{ scope.row.UserInfo.append_json && scope.row.UserInfo.append_json.mobile_system }}
        </template>
      </el-table-column>
      <el-table-column
        prop="seat_user_name"
        fixed="right"
        width="240"
        label="操作"
      >
        <template slot-scope="scope">
          <!-- <el-button
            size="small"
            type="primary"
            plain
            @click="daochu2(scope.row.id)"
            >导出</el-button
          >
          <el-button
            type="primary"
            plain
            size="small"
            @click="quality(scope.row)"
            v-show="scope.row.recording !== null"
            >翻译</el-button
          > -->
          <el-button
            type="primary"
            size="mini"
            @click="quality(scope.row)"
            icon="el-icon-video-play"
            style="font-size: 16px"
            v-if="scope.row.recording"
            :disabled="drawer"
          >
            <span style="font-size: 12px">系统</span>
          </el-button>
          <el-button
            type="primary"
            size="mini"
            @click="numberquality(scope.row)"
            icon="el-icon-video-play"
            style="font-size: 16px"
            :disabled="showAudio"
            v-if="scope.row.CallSmallListInfo.recording"
          >
            <span style="font-size: 12px">平台</span>
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <el-pagination
      class="pagination_bottom"
      background
      layout="total,sizes, prev, pager, next"
      :page-sizes="[20, 50, 100, 200, 500, 1000, 5000]"
      @size-change="handleSizeChange"
      :total="total"
      :page-size="pagesize"
      @current-change="current_change"
      :current-page="currentPage"
    ></el-pagination>
    <el-dialog width="450px" :visible.sync="showAudio">
      <dd-audio
        v-if="showAudio"
        :url="audioUrl"
        :downloadSrc="downloadSrc"
      ></dd-audio>
    </el-dialog>
    <el-drawer
      :visible.sync="drawer"
      :before-close="handleClose"
      :with-header="false"
      :size="size"
    >
      <div class="main" v-loading="!Boolean(playSrc)">
        <div
          class="audio-control"
          v-if="drawer && Boolean(playSrc)"
          :class="changeAudio ? 'audio-active' : ''"
        >
          <Audiovisual
            :playSrc="playSrc"
            @close="close"
            v-if="!changeAudio"
            :sound_time="recordData.sound_time"
          ></Audiovisual>
          <dd-audio v-else :url="playSrc" :downloadSrc="downloadSrc"></dd-audio>
        </div>
        <div class="audio-voice" v-if="drawer">
          <Voicetext
            @changeFileData="changeFileData"
            :fileId="fileId"
            :fileData="fileData"
            :recordHref="downloadSrc1"
          >
          </Voicetext>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { getData } from "@/api/index";
import ddAudio from "@/components/audio/index.vue";
import Audiovisual from "./components/audioVisual.vue";
import Voicetext from "./components/voiceText.vue";
import SearchBoxs from "./components/SearchBoxs.vue";
import { debounce } from "@/utils/tool.js";
import ExportExcel from "@/components/ExportExcel";
export default {
  components: {
    ddAudio,
    Audiovisual,
    Voicetext,
    SearchBoxs,
    ExportExcel,
  },
  data() {
    return {
      E_ids: [], //选中id
      E_condition: {}, //条件
      E_dataLength: 0, //数据长度
      E_searchArr: [
        "mobile",
        "callee",
        "caller",
        "x_number",
        "s_created_at",
        "e_created_at",
        "agent_id",
        "call_type_id",
        "recording",
        "status",
        "s_use_time",
        "e_use_time",
      ], //搜索条件过滤
      E_methodname: "agent_callbak_details", //方法名
      id: "",
      zhanshi: "800px",
      caozuoheight: 0,
      tableData: [],
      total: 0, //默认数据总数
      pagesize: 20, //每页的数据条数
      currentPage: 1, //默认开始页面
      E_ids: [],
      formes: {
        mobile: "",
      },
      field: "1",
      search_field: "",
      value: "",
      switchtext1: "请输入电话号码",
      showAudio: false,
      audioUrl: "",
      pgflag: true,
      size: "50%",
      recordData: [], //当前录音数据
      changeAudio: false,
      drawer: false,
      playSrc: "",
      downloadSrc: "",
      downloadSrc1: "",
      fileId: "",
      fileData: "",
      callTypeArr: [],
      reduct: false,
      searchObj: {},
      caller: "",
      searchbtn: false,
      searchbtnstr: "点击搜索",
      rules: {
        mobile: [
          { required: true, message: "请填入用户手机号", trigger: "change" },
        ],
      },
    };
  },
  created() {
    this.getCallTypeController();
    // this.getlistData({
    //   pagesize: this.pagesize,
    //   page: this.currentPage,
    //   is_recording_page: 1,
    // });
  },
  mounted() {
    setTimeout(() => {
      var H = document.body.clientHeight;
      this.zhanshi = H - this.caozuoheight - 270;
    }, 100);
    const that = this;
    window.onresize = () => {
      var H = document.body.clientHeight;
      that.zhanshi = H - this.caozuoheight - 270;
    };
  },
  methods: {
    calltypecard(val) {
      for (let item of this.callTypeArr) {
        if (val == item.id) return item.card;
      }
    },
    changeAccordion(offhight) {
      var H = document.body.clientHeight;
      this.zhanshi = H - this.caozuoheight - 270 - offhight;
    },
    async numberquality(row) {
      this.showAudio = true;
      this.downloadSrc = row.CallSmallListInfo.recording;
      let recording = row.CallSmallListInfo.recording;
      let str = recording.substring(recording.length - 4, recording.length);
      // if (str !== ".mp3") {
        await getData("call.CallController/recordingToMp3Action", {
          recording,
        }).then((res) => {
          if (res.data) {
            this.audioUrl = "http://" + res.data;
          } else {
            this.audioUrl = recording;
          }
        });
      // } else {
        // this.audioUrl = recording;
      // }
    },
    eserach(obj) {
      this.searchObj = obj;
      // this.esarchang(1);
    },
    async changeFileData() {
      await this.esarchang();
    },
    getCallTypeController() {
      getData("call.CallTypeController/tableListAction?is_smart=1").then(
        (res) => {
          this.callTypeArr = res.data;
        }
      );
    },
    close(value) {
      //选中的角色
      this.changeAudio = value;
    },
    //关闭drawer
    handleClose() {
      this.drawer = false;
    },
    // 播放
    handlePlay(row) {
      this.audioUrl = row.recording ? row.recording : row.recording;
      this.showAudio = true;
    },
    switchover2() {
      this.search_field = "";
      switch (this.field) {
        case "1":
          this.switchtext1 = "输入被叫号码";
          break;
        case "2":
          this.switchtext1 = "输入X号码";
          break;
      }
    },
    inputsearch: debounce(function(e) {
      this.changeMobile(1);
    }),
    changeMobile(flag) {
      this.$refs["formes"].validate((valid) => {
        if (valid) {
          this.searchbtn = true;
          this.searchbtnstr = "搜索中...";
          this.esarchang(flag);
        } else {
          return false;
        }
      });
    },
    handleSelectionChange(val) {
      this.E_ids = [];
      val.forEach((i) => {
        this.E_ids.push(i.id);
      });
    },
    //搜索
    esarchang(flag) {
      if (flag) {
        this.currentPage = 1;
        this.pagesize = 20;
      }
      let params = {
        pagesize: this.pagesize,
        page: this.currentPage,
        is_recording_page: 1,
        ...this.searchObj,
      };
      if (this.caller) {
        params.caller = this.caller;
      }
      if (this.formes.mobile) {
        params.mobile = this.formes.mobile;
      }
      if (this.search_field == "") {
        return this.getlistData(params);
      }
      switch (this.field) {
        case "1":
          params.callee = this.search_field;
          break;
        case "2":
          params.x_number = this.search_field;
          break;
      }
      this.getlistData(params);
    },
    headerCellStyle() {
      return "text-align:center;background-color:#F2f2f2;";
    },
    cellStyle() {
      return "text-align:center;";
    },
    async quality(row) {
      this.fileId = row.id;
      this.downloadSrc = row.recording;
      this.drawer = true;
      let str = row.recording.substring(
        row.recording.length - 4,
        row.recording.length
      );
      // if (str !== ".mp3") {
        await getData("call.CallController/recordingToMp3Action", {
          recording: row.recording,
        }).then((res) => {
          if (res.data) {
            this.playSrc = "http://" + res.data;
            this.downloadSrc1 = "http://" + res.message;
          } else {
            this.playSrc = row.recording;
          }
          this.onQuality(row);
        });
      // } else {
        // this.playSrc = row.recording;
        // this.onQuality(row);
      // }
    },
    onQuality(row) {
      this.fileData = row.recording_word;
      this.recordData = row;
      this.changeAudio = false;
    },
    onreduction() {
      this.reduct = !this.reduct;
    },
    //刷新
    shuaxin() {
      this.pagesize = 20;
      this.currentPage = 1;
      this.field = "1";
      this.search_field = "";
      this.caller = "";
      this.formes.mobile = "";
      this.onreduction();
      // this.getlistData({
      //   pagesize: this.pagesize,
      //   page: this.currentPage,
      //   is_recording_page: 1,
      // });
      this.$message({ message: "刷新成功", type: "success" });
    },
    //请求数据
    getlistData(data) {
      this.E_condition = { ...data, xh_excel: 1 };
      getData("call.CallBakController/pageAction", data).then((res) => {
        this.searchbtn = false;
        this.searchbtnstr = "点击搜索";
        if (res.code !== 200) return this.$message.error(res.message);
        this.tableData = res.data.data;
        this.tableData.forEach(item=>{
          if(item.UserInfo.append_json){
            item.UserInfo.append_json = JSON.parse(item.UserInfo.append_json)
          }
        })
        this.total = res.data.total;
        this.E_dataLength = res.data.total;
      });
    },
    handleSizeChange(val) {
      this.pagesize = val;
      this.changeMobile();
    },
    // 分页
    current_change(currentPage) {
      this.currentPage = currentPage;
      this.changeMobile();
    },
  },
  watch: {
    drawer() {
      if (!this.drawer) {
        this.playSrc = null;
        this.changeAudio = true;
        this.fileData = null;
      }
      ``;
    },
  },
  filters: {
    daType(val) {
      switch (val) {
        case 1:
          return "未拨打";
        case 2:
          return "已拨打";
        case 3:
          return "已接通";
        case 4:
          return "未接通";
      }
    },
  },
};
</script>

<style lang="less" src="@/assets/css/records.less" scoped></style>
<style lang="less" scoped>
.el-form /deep/ .el-form-item__error {
  position: absolute;
  top: 38px;
  left: 0;
}
.searchItem /deep/ .el-form-item__content {
  line-height: 37px;
}
.pagination_bottom /deep/ .el-input__inner {
  height: 28px;
  line-height: 28px;
}
.el-month-table td.today /deep/.cell {
  color: black;
  font-weight: normal;
}
.el-drawer__wrapper {
  top: 60px;
}
.searchItem /deep/ .el-form-item__content {
  line-height: 37px;
}
.pagination_bottom /deep/ .el-input__inner {
  height: 28px;
  line-height: 28px;
}
.head {
  height: 81px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 21px;
  .head-l {
    font-size: 18px;
    display: flex;
    align-items: center;
    color: #333333;
  }
  .head-r {
    button {
      background-color: #f2f4fb;
      color: #333333;
      border: none;
      border-radius: 4px;
      margin-right: 12px;
      padding: 7px 16px;
      font-size: 14px;
    }
    span {
      width: 14px;
      height: 14px;
      margin-right: 19px;
      cursor: pointer;
    }
  }
}
.main {
  display: flex;
  flex-direction: column;
  background-color: #f1f1f3;
  padding: 15px 15px;
  height: 100%;

  .detailed {
    background-color: #fff;
    display: flex;
    flex-wrap: wrap;
    padding: 10px 22px;
    div {
      width: 33%;
      color: #666666;
      font-size: 14px;
      line-height: 27px;
      span {
        margin-left: 45px;
        color: #333333;
      }
    }
  }
  .audio-control {
    height: 155px;
    background-color: #fff;
    padding: 0 20px;
    margin-top: 15px;
    /deep/.el-tabs__nav-wrap .is_top {
      height: 50px;
      line-height: 50px;
    }
  }
  .audio-active {
    padding: 40px 0;
    height: 74px;
  }
  /deep/ .is_top .el-tabs__nav-wrap::after {
    height: 1px !important;
  }
  /deep/ .audio {
    position: relative;
  }
  .audio /dep/ .audio-speed {
    bottom: 5px;
  }
}
</style>
